import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App"; // Updated import path
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { initMsal } from "./services/identity";
import { API_BASE_URL } from "../config";
import "./styles/globals.css";

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(async () => {
  const version = process.env.BUILD_GIT_COMMIT
    ? `v${process.env.APP_VERSION} (${process.env.BUILD_GIT_COMMIT})`
    : `v${process.env.APP_VERSION}`;
  console.log("[My AI Secretary]", version, "| API_BASE_URL:", API_BASE_URL);

  // Initialize MSAL as recommended by Microsoft best practices
  try {
    await initMsal();
    console.log("MSAL initialized successfully in Office.onReady()");
  } catch (error) {
    console.error("Failed to initialize MSAL in Office.onReady():", error);
  }

  root?.render(
    <FluentProvider theme={webLightTheme}>
      <App />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {  // Updated path
    const NextApp = require("./App").default;
    root?.render(
      <FluentProvider theme={webLightTheme}>
        <NextApp />
      </FluentProvider>
    );
  });
}